// core
import React from 'react';
import { Link } from 'react-router-dom'

// settings + utils
import Settings from 'config.js';
import Auth from 'services/Auth.js';
import API from 'utils/API.js';
import CSV from 'utils/CSV.js';

// lib
import Page from 'pages/shared/Page';
import Spinner from 'components/shared/Spinner';

// shared
import PageHeader from 'components/shared/PageHeader';
import ButtonsToolbar from 'components/shared/ButtonsToolbar';
import FiltersToolbar from 'components/shared/filters/FiltersToolbar';
import SortingToolbar from 'components/shared/SortingToolbar';

import MainHeading from 'components/shared/MainHeading';
import PageDataWrapper from 'pages/shared/PageDataWrapper.js';

// page-specific
import ReactFileReader from 'react-file-reader';
import Papa from 'papaparse';
import { callbackify } from 'util';

class ShippingPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      saving: false,
      just_saved: false,
      error: ''
    };

    this.handleData = this.handleData.bind(this);
    this.downloadCSV = this.downloadCSV.bind(this);
  }

  handleData(files) {
    const { groupId, kitId } = this.props.match.params;

    const reader = new window.FileReader();

    reader.onload = (e) => {
      const result = Papa.parse(reader.result, {
        dynamicTyping: true,
        complete: (result) => {
          console.log('----------------------------');
          // first, get keys indices
          const keys = result.data[0];
          const indices = {};
          for (let i=0; i<keys.length; i++) {
            console.log('Key: ' + key);
            const key = keys[i];
            indices[key] = result.data[0].indexOf(key);
          }

          // turn into array of objects
          let requests = [];
          for (let i=1; i<result.data.length; i++) {
            const arr = result.data[i];

            let o = {};
            keys.forEach((key) => {
              o[key] = arr[indices[key]];
            });

            requests.push(o);
          }

          console.log('_______________');
          console.dir(requests);
          console.log('_______________');

          // check stuff
          for (let i=0; i<requests.length; i++) {
            let request = requests[i];

            // check required
            if (!request.id || !request.order_id || !request.kit_id) {
              alert('Required fields missing');

              return false;
            }

            if (request.kit_id != kitId) {
              alert('KIT SBAGLIATO!!!');

              return false;
            };
          }

          // update all requests
          this.setState((prevState) => {
            prevState.saving = true;
            prevState.error = '';

            return prevState;
          }, () => {
            const endpoint = Settings.V3_API_URL + '/kit-orders/shipments';
            const payload = {
              order_items: requests
            };

            API.call('POST', endpoint, payload, (response, error) => {
              if (error || !response.ok) {
                console.error('Error updating statuses');
                console.dir(response);

                this.setState((prevState) => {
                  prevState.saving = false;
                  prevState.error = 'Impossibile salvare' + (error ? ': ' + error : '');

                  return prevState;
                });
              } else {
                this.setState((prevState) => {
                  prevState.saving = false;
                  prevState.just_saved = true;

                  return prevState;
                });
              }

              // reset both error and success message to allow submitting more request
              window.setTimeout(() => {
                this.setState((prevState) => {
                  prevState.just_saved = false;
                  prevState.error = '';

                  return prevState;
                });
              }, 3000);
            });
          });
        }
      });
    }

    reader.readAsText(files[0]);
  }

  downloadCSV() {
    this.setState((prevState) => {
      prevState.fetching = true;

      return prevState;
    }, () => {
      const { groupId, kitId } = this.props.match.params;
      const endpoint = Settings.V3_API_URL + '/reports/orders/warehouse?kit_id=' + kitId;
      API.call('GET', endpoint, {
        access_token: Auth.getToken()
      }, (response, error) => {
        this.setState({
          fetching: false
        });

        if (error) {
          alert(error);

          return false;
        }

        if (!response.data.report || !response.data.report.length) {
          alert('Nessuna richiesta spedita');

          return false;
        }

        const filename = 'Richieste kit_' + kitId + '_' + (new Date()).toISOString() + '.csv';

        CSV.export(filename, response.data.report, ';');
      });
    });
  }

  render() {
    const { groupId, kitId } = this.props.match.params;

    const accessToken = Auth.getToken();
    const dataCSVURL = Settings.V1_API_URL + '/kit-requests?kit_id=' + kitId + '&access_token=' + accessToken + '&offset=0&limit=-1&format=csv';
    const shippingCSVURL = Settings.V1_API_URL + '/kit-requests?kit_id=' + kitId + '&access_token=' + accessToken + '&offset=0&limit=-1&format=csv';

    const buttonStyle = {
      color: '#fff',
      backgroundColor: '#555',
      border:'1px solid #444'
    };

    return (
      <div className="container">
        <p><Link to={"/kit-orders/" + kitId + "/overview/"}><i className="fa fa-arrow-left" /> Torna alle richieste</Link></p>

        <h1>Kit #{kitId.split('-')[0].toUpperCase()}</h1>

        <h2 style={{borderBottom: "2px solid #666", paddingBottom: "10px", marginBottom: '30px'}}><i className="fa fa-truck" /> Spedizioni</h2>

        <div className="row">
          <div className="col-12">
            <h3>1) Aggiorna dati</h3>
            <p>L'aggiornamento del DB avviene upload, modificando il file CSV scaricato da pagina ordini.</p>

            <ul>
              <li>Puoi mettere <code>refused</code> nel campo "<code>status</code>" per indicare che l'ordine e' stato rifiutato</li>
              <li>Puoi mettere <code>shipped</code> nel campo "<code>status</code>", e la data di spedizione in formato "yyyy-mm-dd" nel campo "<code>shipped_on</code>" per indicare che l'ordine e' stato spedito</li>
              <li>Una volta modificato lo stato, non sara' piu' possibile modificare il record</li>
              <li><i className="fa fa-exclamation-triangle" /> Campi obbligatori sono: <strong><code>id</code>, <code>order_id</code>, <code>kit_id</code>, <code>status</code>, <code>shipped_on</code></strong></li>
            </ul>

            <p>NOTE</p>
            <ol>
              <li>Volendo e' possibile modificare l'ordine delle righe</li>
              <li>Volendo e' possibile modificare l'ordine delle colonne, a patto che l'intestazione corrisponda.</li>
              <li>Volendo e' possibile caricare—oltre all'ID di ordine e richiesta—solo le colonne che interessano (<code>status</code> e <code>shipped_on</code>, quindi), a patto che l'intestazione corrisponda.</li>
              <li>Volendo e' possibile caricare solo le righe che interessano, a patto di includere anche l'intestazione.</li>
            </ol>

            <h4>Carica file CSV</h4>
            <div>
              <p>
                {
                  this.state.saving == false ? (
                    this.state.just_saved ? (
                      <span><i className="fa fa-check text-success" /> Fatto.</span>
                    ) : (
                      this.state.error == false && (
                        <ReactFileReader handleFiles={this.handleData} fileTypes={'.csv'} multipleFiles={false}>
                          <button className='btn btn-primary'><i className="fa fa-upload" /> Carica</button>
                        </ReactFileReader>
                      )
                    )
                  ) : (
                    <Spinner message="Salvataggio in corso..." />
                  )
                }
              </p>
              {
                this.state.error && (
                  <div>
                    <p className="text-danger"><i className="fa fa-exclamation-triangle" /> Errore, si prega di riprovare: {this.state.error}</p>
                  </div>
                )
              }
            </div>

            <h3>2) Scarica il file per il magazzino</h3>
            <h4>Scarica</h4>
            <p>Se hai gia' modificato i record o vuoi scaricare nuovamente il file, clicca sul bottone sotto.</p>
            <p>
              {
                this.state.fetching ? <Spinner message="Recupero CSV..." /> : (
                  <a className="btn btn-primary" href="javascript:void(0);" onClick={this.downloadCSV}>
                    <i className="fa fa-download mr-1" /> Scarica
                  </a>
                )
              }
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default ShippingPage;



// WEBPACK FOOTER //
// ./src/pages/kit-orders/ShippingPage.js